<div cdkDropListGroup class="groups">
	@for (column of columns; track column) {
		<div class="column">
			<h1>
				@if (titleTemplate) {
					<ng-template [ngTemplateOutlet]="titleTemplate" [ngTemplateOutletContext]="{ $implicit: column }" />
				} @else {
					<span class="plain-title">
						<label> {{ column.title }} </label>
						@if (column.help) {
							<ic-indicator class="help" [text]="column.help" />
						}
					</span>
				}
			</h1>
			<ul
				cdkDropList
				class="column-list"
				[cdkDropListData]="items[column.name]"
				[cdkDropListDisabled]="disabled"
				[cdkDropListEnterPredicate]="column.enterPredicate || alwaysAllowEnterPredicate"
				[class.column-disabled]="disabled"
				[id]="column.name"
				(cdkDropListDropped)="onChange($event)"
			>
				@for (item of items[column.name]; track item) {
					<li
						cdkDrag
						[cdkDragData]="item"
						[cdkDragDisabled]="item?.itemStatus?.disabled || item?.itemStatus?.loading"
						[class.is-disabled]="item?.itemStatus?.disabled || item?.itemStatus?.loading"
					>
						@if (itemTemplate) {
							<ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
						} @else {
							{{ item }}
						}
					</li>
				}
				@if (paging[column.name]) {
					<li class="paging">
						<ng-template
							[ngTemplateOutlet]="pagingTemplate"
							[ngTemplateOutletContext]="{ $implicit: paging[column.name], column: column.name }"
						/>
					</li>
				}
			</ul>
		</div>
	}
</div>
